
export default {
  status: '',
  token: ''
}
